var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"position-abs align-central text-center"},[_c('img',{staticClass:"width-200",attrs:{"alt":"","src":_vm.logoTransparent}}),_vm._m(0)]),_c('div',{staticStyle:{"position":"fixed","right":"0","bottom":"50px","margin":"auto 0","padding":"10px"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',[_vm._v("Welcome to "),_c('b',[_vm._v("PANDA")]),_vm._v(" Loan System")])
}]

export { render, staticRenderFns }